/* Global imports */
import React, { useEffect, useRef, useState } from 'react';
import pt from 'prop-types';
import * as styles from './cubeNavigation.module.scss';
import Container from '../container';
import Logo from '../../images/logo.svg';
import Link from '/src/components/ui/link';
import { combine } from '/src/helpers/styles';
import Text from '../../components/ui/text';

/* Component definition */
const CubeNavigation = ({ navigationItems, isWhite }) => {
  const [slug, setSlug] = useState('');

  useEffect(() => {
    const hashPosition = window.location.pathname.search(/[#\?]/);
    setSlug(
      window.location.pathname
        .substring(4, hashPosition === -1 ? undefined : hashPosition)
        .replace(/\/$/, '')
    );
  }, []);

  return (
    <div
      className={combine(
        styles.cubeNavigation,
        isWhite && styles.secondaryColor
      )}
    >
      <Container fluid className={styles.innerContainer}>
        <Link link={{ linkToPage: '/' }} className={styles.logoLink}>
          <Logo className={styles.logo} />
        </Link>
        <div className={styles.itemsWrapper}>
          {navigationItems.map((item, index) => (
            <div
              key={index}
              className={combine(
                styles.item,
                item.childItems.find((childItem) => {
                  return childItem.link?.linkToPage?.slug === slug;
                }) && styles.selected
              )}
            >
              <Text as="span" className={styles.menuText}>
                {item.link.text}
              </Text>
              <div id={`sub-menu-${index}`} className={styles.subMenu}>
                {item.childItems.map((subItem, idx) => (
                  <Link
                    link={subItem.link}
                    className={styles.subMenuLink}
                    key={idx}
                    activeClassName={styles.active}
                  >
                    <Text
                      as="span"
                      type="metanavi"
                      className={styles.subMenuLinkText}
                    >
                      {subItem.link.text}
                    </Text>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

CubeNavigation.propTypes = {
  navigationItems: pt.array.isRequired,
  isWhite: pt.bool,
};

CubeNavigation.defaultProps = {
  navigationItems: [],
  isWhite: true,
};

export default CubeNavigation;
